import { DrawingModel, type Handle } from "../DrawingModel";
import type { Chart } from "../../chart/Chart";
import { distToSegment, withAlpha } from "../geometry";

const TOL = 6;

// Parallel channel: anchors[0],[1] main line; anchors[2] sets the parallel offset.
export class ParallelChannel extends DrawingModel {
  type = "channel";
  render(ctx: CanvasRenderingContext2D, chart: Chart) {
    const [a, b, c] = this.anchors;
    const p0 = [this.X(a, chart), this.Y(a, chart)];
    const p1 = [this.X(b, chart), this.Y(b, chart)];
    const p2 = [this.X(c, chart), this.Y(c, chart)];
    const ox = p2[0] - p1[0];
    const oy = p2[1] - p1[1];
    const q0 = [p0[0] + ox, p0[1] + oy];
    const q1 = [p1[0] + ox, p1[1] + oy];

    if (this.style.fillAlpha > 0) {
      ctx.fillStyle = withAlpha(this.style.color, this.style.fillAlpha);
      ctx.beginPath();
      ctx.moveTo(p0[0], p0[1]);
      ctx.lineTo(p1[0], p1[1]);
      ctx.lineTo(q1[0], q1[1]);
      ctx.lineTo(q0[0], q0[1]);
      ctx.closePath();
      ctx.fill();
    }
    this.applyStroke(ctx);
    ctx.beginPath();
    ctx.moveTo(p0[0], p0[1]);
    ctx.lineTo(p1[0], p1[1]);
    ctx.moveTo(q0[0], q0[1]);
    ctx.lineTo(q1[0], q1[1]);
    ctx.stroke();
    ctx.setLineDash([]);
  }
  handles(chart: Chart): Handle[] {
    return this.anchors.map((a, i) => ({ x: this.X(a, chart), y: this.Y(a, chart), kind: i }));
  }
  hitTest(px: number, py: number, chart: Chart) {
    const [a, b, c] = this.anchors;
    const p0 = [this.X(a, chart), this.Y(a, chart)];
    const p1 = [this.X(b, chart), this.Y(b, chart)];
    const p2 = [this.X(c, chart), this.Y(c, chart)];
    const ox = p2[0] - p1[0],
      oy = p2[1] - p1[1];
    return (
      distToSegment(px, py, p0[0], p0[1], p1[0], p1[1]) <= TOL ||
      distToSegment(px, py, p0[0] + ox, p0[1] + oy, p1[0] + ox, p1[1] + oy) <= TOL
    );
  }
}
